module.exports = __webpack_public_path__ + "static/media/CEMY6039.4b3013fa.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/makeup_hair/CEMY6039.JPG
// module id = 365
// module chunks = 0